import { ApplicableCouponsRequest, ApplicableCouponsResponse } from '@/src/types/applicableCoupons'
import {
    AircraftAmenitiesRequest,
    AircraftAmenitiesResponse,
    FullBaggageResponse,
    MiniRuleData,
    SRPBaggageRequest,
    SRPMiniRuleRequest
} from '@/src/types/flight'
import { getCurrentLocale } from '@/src/utils/rtkQuery/getCurrentLocale'
import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react'

const baseQuery = fetchBaseQuery({
    prepareHeaders: headers => {
        const locale = getCurrentLocale()
        headers.set('Accept', 'application/json')
        headers.set('Content-Type', 'application/json')
        headers.set('X-CT-SOURCETYPE', 'web')
        headers.set('preferred-language', locale)
        return headers
    }
})

const baseQueryWithRetry = retry(baseQuery, { maxRetries: 0 })

const SRPFlightDetailsApi = createApi({
    reducerPath: 'SRPFlightDetailsApi',
    baseQuery: baseQueryWithRetry,
    tagTypes: ['BaggageInfo', 'MiniRuleInfo'],
    endpoints: builder => ({
        getBaggageInfo: builder.query<FullBaggageResponse, SRPBaggageRequest>({
            query: body => ({
                url: `/flight/search/v2/freeBaggageInfo`,
                method: 'POST',
                body
            }),
            providesTags: (result, error, arg) => [{ type: 'BaggageInfo', id: arg?.sol[0]?.fre?.fk }]
        }),

        getMiniRuleInfo: builder.query<MiniRuleData[], { payload: SRPMiniRuleRequest[]; isSplrt: boolean }>({
            query: body => ({
                url: `/flight/search/v2/minirule`,
                //url: `/flights/getminirule?domain=www.flyin.com`, // for development as domain will come as localhost
                method: 'POST',
                body
            }),
            providesTags: (result, error, arg) => [{ type: 'MiniRuleInfo', id: arg.payload[0].os?.[0]?.fareKey }]
        }),
        getApplicableCoupons: builder.query<ApplicableCouponsResponse, ApplicableCouponsRequest>({
            query: body => ({
                url: `/flight/search/v2/getSrpCoupons`,
                method: 'POST',
                body
            })
        }),
        getAircraftAmenities: builder.query<AircraftAmenitiesResponse, AircraftAmenitiesRequest>({
            query: ({ airlineCode, aircraftCode, lang }) => ({
                url: `/bff/orbit/v1/itin/aircraft-amenities/${airlineCode}?aircraftCode=${aircraftCode}&lang=${lang}`,
                method: 'GET'
            })
        })
    })
})

export const {
    useGetBaggageInfoQuery,
    useGetMiniRuleInfoQuery,
    useGetApplicableCouponsQuery,
    useGetAircraftAmenitiesQuery
} = SRPFlightDetailsApi
export default SRPFlightDetailsApi
